import React, { useEffect, useState } from "react";
import { ClientLayout } from "@/components/ClientLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { getShopOrders, fmt } from "@/lib/api";
import { ClipboardList } from "lucide-react";
import { useT } from "@/i18n/I18nContext";
import { formatDate } from "@/lib/dates";

const statusBadge = {
  placed: "badge-warn", confirmed: "badge-ok",
  delivered: "bg-[hsl(var(--brand))] text-white", cancelled: "badge-bad",
};

export default function ClientOrders() {
  const { t, td } = useT();
  const [orders, setOrders] = useState([]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { getShopOrders().then(setOrders); }, []);

  return (
    <ClientLayout>
      <h1 className="mb-5 text-2xl font-semibold tracking-tight">{t("client.myOrdersTitle")}</h1>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-base">
            <ClipboardList className="h-4 w-4 text-[hsl(var(--brand))]" /> {t("client.orderHistory")} ({orders.length})
          </CardTitle>
        </CardHeader>
        <CardContent>
          {orders.length === 0 ? (
            <div className="flex flex-col items-center py-12 text-center">
              <ClipboardList className="h-10 w-10 text-muted-foreground/50" />
              <p className="mt-3 text-sm text-muted-foreground">{t("client.noOrdersYet")}</p>
            </div>
          ) : (
            <div className="overflow-x-auto thin-scroll">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>{t("client.orderCode")}</TableHead>
                    <TableHead>{t("client.colItems")}</TableHead>
                    <TableHead className="text-right">{t("common.total")}</TableHead>
                    <TableHead>{t("common.status")}</TableHead>
                    <TableHead>{t("common.date")}</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {orders.map((o) => (
                    <TableRow key={o.id} data-testid={`my-order-${o.id}`}>
                      <TableCell className="font-mono text-xs">{o.order_code}</TableCell>
                      <TableCell className="text-sm text-muted-foreground">
                        {(o.items || []).map((it) => `${td(it.product_type)} ${fmt(it.quantity, 2)}${it.unit}`).join(", ")}
                      </TableCell>
                      <TableCell className="text-right font-mono tabular-nums">{fmt(o.total, 2)} {o.currency}</TableCell>
                      <TableCell><Badge className={statusBadge[o.status]}>{t(`status.${o.status}`)}</Badge></TableCell>
                      <TableCell className="text-xs text-muted-foreground">{formatDate(o.created_at)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>
    </ClientLayout>
  );
}
